export const largeAreaSize = 1000
